import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import AdminPage from "./pages/AdminPage";
import GarageTerms from "./pages/GarageTerms";
import OnboardingPage from "./pages/OnboardingPage";

// Web-only App component that excludes React Native dependencies
function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Routes>
          <Route path="/" element={<OnboardingPage />} />
          <Route path="/onboarding" element={<OnboardingPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/garage-terms" element={<GarageTerms />} />
          <Route path="/test-terms" element={<GarageTerms />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App; 